<!-- @format -->
<script lang="ts">
  import { user_likes } from "~/components/fragment-sets/campaign/store";
  import CampaignImage from "./CampaignImage.svelte";
  import type { Translator } from "~/service/l10n";
  import { parseDate_dd_MM_yy } from "~/util/date-n-time";

  export let item: OrangeAds;
  export let t: Translator

  let is_liked = user_likes.isLiked(item.id);

  $: has_exception = item.exceptional_start_date && item.exceptional_end_date;

  function toggleLike() {
    is_liked = user_likes.toggle(item.id);
  }

</script>

{#if item.name || item.description}
  <div class="col-12 col-md-6 col-lg-4 mb-4">
    <div class="content h-100 border">
      <div class="head">
        {#if item.weekday_group}
          <div class="weekday_group">
            {item.weekday_group}
          </div>
        {/if}
        <i class="far fa-heart save-offer"
          class:fas={is_liked}
          on:click={toggleLike} on:keypress={toggleLike}
          role="button" tabindex="0" />
      </div>
      <div class="px-5 mb-3">
        <CampaignImage img_src={item.picref_original} alt={item.name} />
      </div>
      <p class="text shop-name font-reliable">{item.shop_name}</p>
      <p class="text">{item.name}</p>
      <p class="text">{item.description}</p>
      <p class="text">{item.discount_price}</p>
      {#if item.original_price}
        <p class="text">(norm: {item.original_price})</p>
      {/if}
      {#if has_exception}
        <p class="text mt-2 text-muted">
          {t`campaign-offers.valid`}: {item.exceptional_start_date}–{item.exceptional_end_date}</p>
      {/if}
    </div>
  </div>
{/if}

<style>
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }

  .save-offer {
    font-size: 38px;
    color: #e44c40;
    cursor: pointer;
  }

  .content {
    background-color: #fff;
    padding: 1rem;
    margin-bottom: 2rem;
  }

  .weekday_group {
    background-color: var(--brandColor2);
    color: #fff;
    width: 45px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 14px;
    text-transform: capitalize;
  }

  p.text {
    margin-bottom: 0;
    text-align: center;
  }
  .shop-name {
    font-size: 21px;
    font-family: "Reliable", sans-serif !important;
    text-transform: uppercase;
  }
</style>
